module.exports = __webpack_public_path__ + "img/img-bg-unitel.cc2fc026.svg";